import React from "react";
import * as AI_Icons from "react-icons/ai";
import * as FC_Icons from "react-icons/fc";
import * as RI_Icons from "react-icons/ri";

type Props = { name: string; size?: number };

export const DynamicIcon: React.FC<Props> = ({ name, size = 16 }) => {
  let lib: Record<string, React.ComponentType<{ size?: number }>> | null = null;
  if (name.startsWith("Ai")) lib = AI_Icons as any;
  else if (name.startsWith("Fc")) lib = FC_Icons as any;
  else if (name.startsWith("Ri")) lib = RI_Icons as any;

  const Icon = lib?.[name];
  if (!Icon) return null;
  return React.createElement(Icon, { size });
};
